export const TOKEN = 'welcome_church_token';
export const USER_TYPE = 'welcome_church_user_type';
export const TITLE = 'Welcome Church Resource Hub';
export const VALIDATION_TEXT = 'Please enter valid values.';
